import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Users, Palette, Layers, Zap, Clock, TrendingUp } from 'lucide-react';

export default function UseCaseAgencies() {
  return (
    <SubpageTemplate 
      title="Creative Agencies"
      subtitle="Deliver at 10x"
      description="Supercharge your agency's output. From high-fidelity prototypes to fully published client apps, deliver superior quality in a fraction of the time."
      icon={Layers}
      features={[
        {
          title: "White Labeling",
          description: "Deliver builds under your own brand with custom domains and client-facing previews.",
          icon: Palette
        },
        {
          title: "Speed to Market",
          description: "Go from client brief to a functional concept in minutes during your initial pitch.",
          icon: Clock
        },
        {
          title: "Profit Margins",
          description: "Reduce overhead by automating the repetitive parts of development and design.",
          icon: TrendingUp
        }
      ]}
    />
  );
}
